export enum UILayoutVersion {
  Classic = 'classic',
  Modern = 'modern',
  Mobile = 'mobile',
}
